export enum EColors {
  orange = "orange",
  gray = "gray",
  green = "green",
  lightgrey = "lightgrey",
  black = "black",
  purple = "purple",
  blue = "blue",
}

export enum EVariants {
  colorOnHover = "colorOnHover",
  default = "default",
  primary = "primary",
  text = "text",
  price = "price",
}

export enum ESubPriceType {
  secondary = "secondary",
}

export enum ELoaderTheme {
  dark = "dark",
  light = "light",
}
